export const MM_PORTFOLIOS = [1] as const;
export const MM_LABEL = "Money Markets";
